import { createFileRoute, Link } from '@tanstack/react-router';
import { Alert, Button, Card, Center, Stack, Text, Title } from '@mantine/core';
import { IconAlertTriangle, IconCreditCard } from '@tabler/icons-react';
import { motion } from 'framer-motion';

/**
 * Interstitial shown when a vendor's subscription has lapsed. The route
 * guard (Vendor.status === 'Archived' equivalent) redirects every
 * protected vendor route here until they pick a plan.
 */
function NoActivePlan() {
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
      <Center mih={400}>
        <Card maw={520} w="100%">
          <Stack align="center" gap="md">
            <IconAlertTriangle size={64} stroke={1.2} color="var(--mantine-color-yellow-6)" />
            <Title order={3}>No active plan</Title>
            <Alert color="yellow" w="100%">
              Your subscription has lapsed or you haven't picked a plan yet. Reactivate a plan to
              regain access to chat, campaigns, and integrations.
            </Alert>
            <Text c="dimmed" ta="center" size="sm">
              Your contacts, message history, and bot configurations are safe — nothing has been
              deleted. Pick up where you left off as soon as a plan is active.
            </Text>
            <Button
              component={Link}
              to="/vendor/subscription"
              leftSection={<IconCreditCard size={16} />}
            >
              View plans
            </Button>
          </Stack>
        </Card>
      </Center>
    </motion.div>
  );
}

export const Route = createFileRoute('/vendor/no-active-plan')({ component: NoActivePlan });
